import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { ConfirmPopup } from 'primeng/confirmpopup';
import { ApiService } from '../../../../services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Contatto } from '../../../../shared/interface';

@Component({
  selector: 'app-modifica-contatto-backoffice',
  templateUrl: './modifica-contatto-backoffice.component.html',
  styleUrl: './modifica-contatto-backoffice.component.css'
})
export class ModificaContattoBackofficeComponent {

  @ViewChild("confirmDeletePopupRef") confirmPopup!: ConfirmPopup;

  constructor(private apiService: ApiService, private router: Router, private route: ActivatedRoute, private cdr: ChangeDetectorRef, private confirmationService: ConfirmationService) { }  

  formContatti!: FormGroup;  

  contatto?: Contatto;

  ngOnInit(): void {    

    this.formContatti = new FormGroup({
      titolo: new FormControl(null, Validators.required),      
      descrizione: new FormControl(null, Validators.required),        
    })

    this.route.params.subscribe(params => {
      const id = params['id'];

      this.apiService.getContatto(id).subscribe({
        next: (data) => this.contatto = data,
        error: (err) => this.router.navigate(['/backoffice/contatti']),
        complete: () => {

          this.formContatti.patchValue({
            titolo: this.contatto?.titolo,            
            descrizione: this.contatto?.descrizione,            
          })

        }
      })

    })
  }

  onDescrizione(e: any) {    
    this.cdr.detectChanges();
  }

  onDeleteContattoPopup(event: Event) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: "Sei sicuro di voler eliminare il contatto?",
      reject: () => this.confirmationService.close(),
      accept: () => {
        this.apiService.deleteContatto(this.contatto!.id).subscribe({
          next: (data) => this.apiService.setContatti(),
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
          complete: () => {
            this.confirmationService.close()
            this.router.navigate(['/backoffice/contatti']);
            this.apiService.message("success", "Eliminazione", "Il contatto è stato eliminato con successo")
          }
        })
      }
    });
  }

  onDelete() {
    this.confirmPopup.accept();
  }

  onAnnulla() {
    this.confirmPopup.reject();
  }

  onSubmit() {

    const contatto = {
      titolo: this.formContatti.get('titolo')?.value,
      descrizione: this.formContatti.get('descrizione')?.value
    }

    this.apiService.updateContatto(contatto, this.contatto!.id).subscribe({
      next: (data) => this.apiService.setNotizie(),        
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {
        this.router.navigate(['/backoffice/contatti'])
        this.apiService.message('success', 'Modifica', "Modifica effettuata con successo!")
      }
    })

  }

}
